/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "../SelectMission.css";
import PropTypes from "prop-types";
import { getProjectThumbStyle, getContrastTextColor, resolveThemeColors } from "../../../assets/helper.js";
import { getProjectTitle } from "../../../assets/projectTitleHelper.js";
import { withRouter } from "react-router-dom";
import { NumericFormat } from "react-number-format";

class MissionItem extends Component {
  render() {
    const currentAmount = parseFloat(this.props.mission.currentAmount).toFixed(
      2
    );

    const amountBool = this.props.mission.targetAmount > 0;
    const currentAmountBool = currentAmount > 0;

    const progressStyle = {
      background: "#" + this.props.progressBarColor,
    };

    const progressBgStyle = {
      background: "#" + this.props.progressBarColor,
      opacity: "0.3",
    };

    const frameDotStyle = {
      background: "#" + this.props.progressBarColor,
    };

    const resolved = resolveThemeColors(this.props.headerColor, this.props.buttonColor);
    const buttonStyle = {
      background: "#" + resolved.headerColor,
      color: getContrastTextColor(resolved.headerColor, resolved.buttonColor),
    };

    let progressContainerStyle = {};
    if (this.props.mission.targetAmount === 0.0) {
      progressStyle.width = "100%";
      progressContainerStyle.display = "none";
    } else {
      let percentage = currentAmount / this.props.mission.targetAmount;
      percentage *= 100.0;
      progressStyle.width = String(percentage) + "%";
    }

    const headerBackgroundPicture = this.props.mission.headerBackgroundPicture;
    const headerImg = headerBackgroundPicture
      ? headerBackgroundPicture.split(",")
      : null;
    const headerPictureStyle = getProjectThumbStyle(headerImg);

    const goalText = amountBool ? (
      <div className="SelectMission-goal">
        <div className="SelectMission-raisedContainer">
          <div className="SelectMission-amountDot" style={frameDotStyle} />
          <div className="SelectMission-amountContainer">
            <NumericFormat
              decimalSeparator="."
              displayType="text"
              className="SelectMission-amountNumber"
              valueIsNumericString={true}
              value={currentAmount}
              allowNegative={false}
              thousandSeparator={true}
              prefix={"HK$"}
              fixedDecimalScale={true}
              decimalScale={2}
            />
            <div className="SelectMission-amountRaised">
              {this.props.languageObj.MissionItem.amountRaised}
            </div>
          </div>
        </div>

        <div className="SelectMission-alreadyRaisedContainer">
          <div className="SelectMission-raisedDot" style={progressBgStyle} />
          <div className="SelectMission-amountContainer">
            <NumericFormat
              decimalSeparator="."
              displayType="text"
              className="SelectMission-raisedNumber"
              valueIsNumericString={true}
              value={this.props.mission.targetAmount}
              allowNegative={false}
              thousandSeparator={true}
              prefix={"HK$"}
              fixedDecimalScale={true}
              decimalScale={2}
            />

            <div className="SelectMission-goalRaised">
              {this.props.languageObj.MissionItem.goal}
            </div>
          </div>
        </div>
      </div>
    ) : (
      ""
    );

    const goalProgress = currentAmountBool ? (
      <div
        className="SelectMission-progressOuterContainer"
        style={progressContainerStyle}
      >
        <div className="SelectMission-progressContainer">
          <div className="SelectMission-progressBg" style={progressBgStyle} />
          <div className="SelectMission-progress" style={progressStyle}></div>
        </div>
      </div>
    ) : (
      ""
    );

    const onClick = () => {
      this.props.history.push({
        pathname: "/MissionDetails",
        search: "?no=" + this.props.mission.id,
        state: (this.props.location && this.props.location.state) || {},
      });
    };

    return (
      <div className="SelectMission-frame">
        {this.props.mission.headerBackgroundPicture && this.props.mission.headerBackgroundPicture.length > 0 ? (
          <div
            className="SelectMission-picture"
            style={headerPictureStyle}
          ></div>
        ) : null}
        <div className="SelectMission-bottomContainer">
          <div className="SelectMission-text">{getProjectTitle(this.props.language, this.props.mission)}</div>

          {goalProgress}
          {goalText}

          <div
            className="SelectMission-button"
            data-testid="selectmission-mission-btn"
            onClick={onClick}
            style={buttonStyle}
          >
            {this.props.mission.donation === true ? (
              <span> {this.props.languageObj.donate}</span>
            ) : (
              <span> {this.props.languageObj.pay}</span>
            )}
          </div>
        </div>
      </div>
    );
  }
}

MissionItem.propTypes = {
  mission: PropTypes.object,
  progressBarColor: PropTypes.string,
  headerColor: PropTypes.string,
  buttonColor: PropTypes.string,
  languageObj: PropTypes.object,
  language: PropTypes.string,
  cardPaymentsStatus: PropTypes.string,
  transfersStatus: PropTypes.string,
};

export default withRouter(MissionItem);
